import { Directive, Input } from '@angular/core';
import { TemplateRef, ViewContainerRef } from '@angular/core';
import { RolePermissionModel } from '@core/models/identidade/role-permission.model';
import { UserControllerService } from '@core/services/outros/user-controller.service';
import { UserPermissionsService } from '@core/services/outros/user-permissions.service';

@Directive(
  {
    selector: '[permission]'
  }
)
export class PermissionDirective {

  constructor(
    private templateRef: TemplateRef<any>,
    private userService: UserControllerService,
    private viewContainer: ViewContainerRef,
    private _userPermissions: UserPermissionsService
  ) { }

  @Input() set permission(name: string) {

    (this._userPermissions.getPermissionsList().length <= 0) && this._userPermissions.recoverFromStorage();

    let permissions = this._userPermissions.getPermissionsList();

    let permission: RolePermissionModel = permissions.find(x => x.permission.hash == name);

    if (!permission || !permission.enabled) {
      this.viewContainer.clear();
    } else if (permission.enabled) {
      this.viewContainer.createEmbeddedView(this.templateRef);
    }
  }
}
